module.exports = __webpack_public_path__ + "static/footer1@3x-58c58b7cdd248bbdff7d3fe0da46bd3a.png";